import { useCallback, useEffect, useState } from 'react';
import { fetchAnnouncementStatuses } from './actions';
import { AnnouncementStatusesReturnType, IAnnouncementStatus } from './types';

export function useAnnouncementStatuses(
	getOnRender: boolean | undefined = undefined
): AnnouncementStatusesReturnType {
	const [data, setData] = useState<IAnnouncementStatus[]>([]);
	const [loading, setLoading] = useState<boolean>(false);

	const getStatuses = useCallback(async () => {
		try {
			setLoading(true);
			const response = await fetchAnnouncementStatuses();
			setData(response);
			return response;
		} catch {
			return [];
		} finally {
			setLoading(false);
		}
	}, []);

	useEffect(() => {
		if (getOnRender) {
			getStatuses();
		}
	}, [getOnRender, getStatuses]);

	return { data, loading, getStatuses };
}
